import { atom, useAtom, useSetAtom } from "jotai";

export const resetLedgerAtom = atom(false);
const useResetLedger = () => {
  const atom = useAtom(resetLedgerAtom);
  return atom;
};

export const useSetResetLedger = () => useSetAtom(resetLedgerAtom);

export default useResetLedger;
